import { Reveal } from "@/lib/reveal";
import { Link } from "react-router-dom";
import { Overline } from "./Primitives";
import { UtensilsCrossed, Sprout, Archive } from "lucide-react";

const MONTHS = [
  { name: "January", cook: "Barley & root vegetable broth", forage: "Wild garlic shoots & chickweed", preserve: "Marmalade from Seville oranges" },
  { name: "February", cook: "Slow-braised beef with dumplings", forage: "Nettle tops & winter cress", preserve: "Bottled forced rhubarb" },
  { name: "March", cook: "Leek & potato soup", forage: "Wild garlic & dandelion leaves", preserve: "Wild garlic pesto in oil" },
  { name: "April", cook: "New-season lamb with mint", forage: "Hawthorn leaves & sorrel", preserve: "Pickled wild garlic buds" },
  { name: "May", cook: "Asparagus & herb tart", forage: "Elderflower & hawthorn blossom", preserve: "Elderflower cordial" },
  { name: "June", cook: "Strawberry & elderflower fool", forage: "Elderflower, chamomile & clover", preserve: "Strawberry & rose petal jam" },
  { name: "July", cook: "Summer garden gazpacho", forage: "Meadowsweet & wild raspberries", preserve: "Raspberry & redcurrant jelly" },
  { name: "August", cook: "Runner bean & tomato supper", forage: "Blackberries & rosehips", preserve: "Bramble jelly & tomato chutney" },
  { name: "September", cook: "Plum & almond cobbler", forage: "Elderberries, sloes & crab apples", preserve: "Spiced plum jam & elderberry syrup" },
  { name: "October", cook: "Apple & sage pork with mash", forage: "Sweet chestnuts & rosehips", preserve: "Sloe gin & apple butter" },
  { name: "November", cook: "Parsnip & chestnut soup", forage: "Late rosehips & hedgerow haws", preserve: "Piccalilli & pickled walnuts" },
  { name: "December", cook: "Mulled cider & spiced fruit cake", forage: "Holly, ivy & pine for the mantel", preserve: "Mincemeat & cranberry conserve" },
];

export const Almanac = () => {
  const m = MONTHS[new Date().getMonth()];
  const items = [
    { icon: UtensilsCrossed, label: "To cook this week", value: m.cook, to: "/recipes" },
    { icon: Sprout, label: "To forage this week", value: m.forage, to: "/herbal-wisdom" },
    { icon: Archive, label: "To preserve this week", value: m.preserve, to: "/pantry-preserving" },
  ];
  return (
    <section className="bg-brand-linen/50 paper-texture border-y border-brand-linen" data-testid="almanac-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <Reveal>
          <div className="text-center max-w-xl mx-auto mb-12">
            <Overline>The Cottage Almanac · {m.name}</Overline>
            <h2 className="text-3xl sm:text-4xl font-light mt-3 leading-tight">A gentle word for the week</h2>
          </div>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-8">
          {items.map((it, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <Link to={it.to} className="group block text-center px-6" data-testid={`almanac-item-${i}`}>
                <it.icon size={26} className="text-brand-copper mx-auto mb-5 group-hover:scale-110 transition-transform duration-500" strokeWidth={1.4} />
                <span className="overline text-[0.62rem] block mb-3">{it.label}</span>
                <p className="font-serif text-2xl leading-snug text-brand-charcoal group-hover:text-brand-olive transition-colors">{it.value}</p>
                <span className="link-underline inline-block mt-3 font-sans text-[0.62rem] uppercase tracking-[0.16em] text-brand-copper">Explore</span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
